<template>
  <GoogleLogin id="google-login-button" :callback="callback"/>
</template>

<script>
export default {
  name: "GoogleButton",
  methods: {
    callback(response){
      this.$emit('callback', response);
    }
  }
}
</script>


